class Plugin {
  constructor() {
  }

  getMessageTypes() {}

  getCommands() {}

  on() {}

  emit() {}
}

export default Plugin;
